/**
 * Platform detection utilities for build-time optimization
 * Uses environment variables set during build to determine target platform
 */

// Build-time platform detection from environment variables
export const PLATFORM = import.meta.env.VITE_PLATFORM || "web";

// Platform constants
export const IS_WEB = PLATFORM === "web";
export const IS_IOS = PLATFORM === "ios";
export const IS_ANDROID = PLATFORM === "android";
export const IS_NATIVE = IS_IOS || IS_ANDROID;

// Platform type for type safety
export type Platform = "web" | "ios" | "android";

/**
 * Get current platform
 */
export function getPlatform(): Platform {
  return PLATFORM as Platform;
}

/**
 * Check if running on specific platform
 */
export function isWeb(): boolean {
  return IS_WEB;
}

export function isIOS(): boolean {
  return IS_IOS;
}

export function isAndroid(): boolean {
  return IS_ANDROID;
}

export function isNative(): boolean {
  return IS_NATIVE;
}

/**
 * Platform-specific configuration helper
 */
export function platformConfig<T>(config: {
  web?: T;
  ios?: T;
  android?: T;
  native?: T;
  default?: T;
}): T | undefined {
  if (IS_WEB && config.web) return config.web;
  if (IS_IOS && config.ios) return config.ios;
  if (IS_ANDROID && config.android) return config.android;
  if (IS_NATIVE && config.native) return config.native;
  return config.default;
}
